module.exports = __webpack_public_path__ + "img/over.36156761.jpg";